<template>
  <div class="row my-1">
    <div class="py-0 ma-0 col-12 fs-14">
      {{ text }}
    </div>
    <template v-if="showInfo">
      <div v-if="info" class="py-0 ma-0 col-12 fs-14">
        {{ info }}
      </div>
      <div v-if="html" v-html="html" class="py-0 ma-0 col-12 fs-14"></div>
    </template>

    <v-btn
      v-else
      class="col-auto py-0 ma-0"
      elevation="0"
      dark
      text
      x-small
      @click="showInfo = true"
      >Click for more
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "CustomToast",
  data: () => ({
    showInfo: false,
  }),
  props: {
    text: { type: String, default: "" },
    info: { type: String, default: "" },
    type: { type: String, default: "Y" },
    html: { type: String, default: "" },
  },
};
</script>

<style scoped></style>
